import api from "../services/api";

export const getDashboardSummary = (params) =>
  api.get("/api/contact-dashboard/summary", { params });
export const getEngagementMetrics = (params) =>
  api.get("/api/contact-dashboard/engagement", { params });
